import { Command } from 'commands/Commands';

export class ChangeAddressCity extends Command {
  type: string = 'ChangeAddressCity';
  priority: number = 100;
}
